<div class="p-4">
    <div class="container">
        <h1>Hi {{user?.firstName}}!</h1>
        <p>You're logged in with Angular!!</p>
    </div>
</div>